module.exports = __webpack_public_path__ + "img/Slider3.e200bbf6.svg";